/* eslint-disable linebreak-style */
import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  OFFLINE_STATE,
  UPDATE_MASTER_CASE_REASONS_MAP,
  UPDATE_PAYMENT_STATUS_MAP,
  SET_DEFAULT_STATE,
  UPDATE_CASE_STATUS_MAP
} from '../actions/login'
import {
  DASHBOARD_STATS,
  GET_LIST,
  PULLED_CASE,
  IS_STATUS_ONLINE,
  DASHBOARD_RESET,
  EXCEL_URL,
  API_FAIL
} from '../actions/dashboard'
import {
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_FAIL,
  FILE_UPLOAD_CHOSEN
} from '../actions/uploadcsv'
import { DROP_OPP_SUCCESS, DROP_OPP_FAIL } from '../actions/dropOpportunity'
import {
  CITY_LIST,
  RAM_LIST,
  AGENT_LIST,
  GET_LIST_SEARCH,
  EXCEL_URL_FOR_SEARCH,
  CLEAR_EXCEL_URL,
  MASS_UPDATE_SUCCESS,
  DOWNLOAD_EXCEL_REQUEST_SUCCESS
} from '../actions/search'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR,
  SHOW_SNACKBAR_TOASTR_HIDE
} from '../actions/loading'
import {
  UPDATE_ORDER_DOCUMENTS,
  UPDATE_DEVELOPER_DETAILS,
  UPDATE_LEGAL_ENTITIES,
  DELETE_ORDER_DOCUMENTS,
  INVOICE_DELETED,
  ORDER_REFRESHED,
  ORDER_GET,
  REASON_LIST,
  REFRESH_BROKER_DOCUMENTS,
  ORDER_DETAILS_UPDATED,
  PAYMENT_MODE_UPDATED
} from '../actions/order'
import { TBU_DASHBOARD } from '../actions/tbuDashboard'
import { UPDATE_INVOICE_MONTH } from '../actions/invoiceMonth'
import {
  CHILD_USER_LIST,
  CHILD_USER_LIST_RESET,
  USER_UPDATE_FAIL,
  USER_UPDATE_RESET,
  USER_UPDATE_SUCCESS,
  SHOW_LOADER,
  HIDE_LOADER
} from '../actions/userManagement'

import {
  ACCOUNT_PAYMENT_BUCKET_DETAILS_IN_PROGRESS,
  ACCOUNT_PAYMENT_BUCKET_DETAILS_SUCCESS,
  ACCOUNT_PAYMENT_BUCKET_DETAILS_ERROR,
  YES_BANK_AMOUNT_TRANSFER_SUCCESS
} from '../actions/yesBankWalletTransfer'

export const defaultState = {
  isFetching: false,
  isLoggedIn: false,
  didInvalidate: false,
  userInfo: null,
  isRcmAdmin: false,
  caseReasonsMap: {},
  caseStatusMap: {},
  paymentStatusMap: {},
  documents: {},
  orderUpdated: {},
  paymentModeUpdated: {},
  isSalesRoleOnly: false,
  refreshOrder: false,
  brokerDocuments: {},
  developerDetails: {},
  legalEntityDetails: {},
  massUpdateDone: {},
  downloadExcelRequestDone: {},
  reasonList: [],
  order: {},
  counter: 0,
  loadingMessages: [],
  snackbar: {
    open: false,
    message: ''
  },
  posts: []
}
export default (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_SNACKBAR_TOASTR:
      return {
        ...state,
        snackbar: {
          open: true,
          message: action.message
        }
      }
    case UPDATE_ORDER_DOCUMENTS:
      return {
        ...state,
        documents: {
          ...state.documents,
          [action.id]: action.documents
        }
      }
    case UPDATE_DEVELOPER_DETAILS:
      return {
        ...state,
        developerDetails: {
          ...state.developerDetails,
          [action.id]: action.detail
        }
      }
    case UPDATE_LEGAL_ENTITIES:
      return {
        ...state,
        legalEntityDetails: {
          ...state.legalEntityDetails,
          [action.id]: action.detail
        }
      }
    case DELETE_ORDER_DOCUMENTS: {
      const documents = state.documents
      delete documents[action.orderCaseId]
      return {
        ...state,
        documents: {
          ...documents
        }
      }
    }
    case INVOICE_DELETED:
      return {
        ...state,
        refreshOrder: true
      }
    case UPDATE_INVOICE_MONTH:
      return {
        ...state,
        invoiceMonth: action.month
      }
    case ORDER_GET:
      return {
        ...state,
        order: action.order
      }
    case REFRESH_BROKER_DOCUMENTS:
      return {
        ...state,
        brokerDocuments: action.brokerDocuments
      }
    case ORDER_DETAILS_UPDATED:
      return {
        ...state,
        orderUpdated: {}
      }
    case PAYMENT_MODE_UPDATED:
      return {
        ...state,
        paymentModeUpdated: {}
      }
    case MASS_UPDATE_SUCCESS:
      return {
        ...state,
        massUpdateDone: {}
      }
    case DOWNLOAD_EXCEL_REQUEST_SUCCESS:
      return {
        ...state,
        downloadExcelRequestDone: {}
      }
    case REASON_LIST:
      return {
        ...state,
        reasonList: action.reasonList
      }
    case ORDER_REFRESHED:
      return {
        ...state,
        refreshOrder: false
      }
    case SHOW_SNACKBAR_TOASTR_HIDE:
      return {
        ...state,
        snackbar: {
          open: false,
          message: ''
        }
      }
    case LOAD_COUNT_DECREMENT: {
      state.loadingMessages.pop()
      return {
        ...state,
        counter: state.counter - 1,
        loadingMessages: [...state.loadingMessages]
      }
    }
    case LOAD_COUNT_INCREMENT:
      return {
        ...state,
        counter: state.counter + 1,
        loadingMessages: [
          action.message || 'Network Call in progress.',
          ...state.loadingMessages
        ]
      }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        showError: false,
        isLoggedOut: true,
        isLoggedIn: false,
        isAdmin: null,
        isSalesRoleOnly: false,
        isRcmAdmin: false,
        userInfo: null
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isLoggedOut: false,
        hasLoginFailed: false,
        isSalesRoleOnly: action.isSalesRoleOnly,
        isRcmAdmin: action.isRcmAdmin,
        isAdmin: action.userInfo.roles.indexOf('Admin') !== -1,
        filters: null,
        dashboard: null,
        userInfo: action.userInfo
      }
    case OFFLINE_STATE:
      return {
        ...state,
        hasLoginFailed: true,
        isLoggedIn: false
      }
    case LOGIN_FAIL:
      return {
        ...state,
        showError: true,
        hasLoginFailed: true,
        isLoggedOut: true,
        errorMessage: action.message,
        isLoggedIn: false
      }
    case DASHBOARD_STATS:
      return {
        ...state,
        filters: action.payload.filters,
        dashboard: action.payload.dashboard
      }
    case DASHBOARD_RESET:
      return {
        ...state,
        filters: null,
        dashboard: null
      }
    case TBU_DASHBOARD:
      return {
        ...state,
        tbuDashboard: action.data
      }
    case GET_LIST_SEARCH:
      return {
        ...state,
        searchData: action.data
      }
    case GET_LIST:
      return {
        ...state,
        data: action.data
      }
    case PULLED_CASE:
      return {
        ...state,
        pulledCase: action.pulledCase
      }
    case IS_STATUS_ONLINE:
      return {
        ...state,
        isStatusOnline: action.isStatusOnline,
        isStatusUpdated: true
      }
    case EXCEL_URL:
      return {
        ...state,
        excelUrl: action.excelUrl,
        excelUrlForSearch: null
      }
    case EXCEL_URL_FOR_SEARCH:
      return {
        ...state,
        excelUrl: null,
        excelUrlForSearch: action.excelUrlForSearch
      }
    case CLEAR_EXCEL_URL:
      return {
        ...state,
        excelUrl: null,
        excelUrlForSearch: null
      }
    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        showMessage: true,
        fileUploadData: action.payload
      }
    case FILE_UPLOAD_FAIL:
      return {
        ...state,
        showMessage: true,
        fileUploadData: {
          error: true
        }
      }
    case FILE_UPLOAD_CHOSEN:
      return {
        ...state,
        showMessage: false,
        fileUploadData: {}
      }
    case DROP_OPP_SUCCESS:
      return {
        ...state,
        snackbar: {
          open: true,
          message: action.payload
        }
      }
    case DROP_OPP_FAIL:
      return {
        ...state,
        snackbar: {
          open: true,
          message: action.message
        }
      }
    case CITY_LIST:
      return {
        ...state,
        cities: action.cities,
        citiesIdNameMap: action.citiesIdNameMap
      }
    case AGENT_LIST:
      return {
        ...state,
        agents: action.agents
      }
    case RAM_LIST:
      return {
        ...state,
        typeAheadSource: action.payload
      }
    case UPDATE_MASTER_CASE_REASONS_MAP:
      return {
        ...state,
        caseReasonsMap: action.masterReasonMap
      }
    case UPDATE_CASE_STATUS_MAP:
      return {
        ...state,
        caseStatusMap: action.caseStatusMap
      }
    case UPDATE_PAYMENT_STATUS_MAP:
      return {
        ...state,
        paymentStatusMap: action.paymentStatusMap
      }
    case SET_DEFAULT_STATE:
      return {
        ...defaultState
      }
    case API_FAIL:
      return {
        ...state,
        snackbar: {
          open: true,
          message: action.errMsg || 'Some error occured.'
        }
      }
    case CHILD_USER_LIST:
      return {
        ...state,
        childUserList: action.childUserList,
        childUserListTotalCount: action.childUserListTotalCount,
        managerList: action.managerList,
        allChildListMap: action.allChildListMap,
        userUpdationSuccess: '',
        userIdNameChildMapping: action.userIdNameChildMapping,
        userIdChildMap: action.userIdChildMap,
        userEmpCodeMap: action.userEmpCodeMap
      }
    case CHILD_USER_LIST_RESET:
      return {
        ...state,
        childUserList: action.childUserList
      }
    case USER_UPDATE_RESET:
      return {
        ...state,
        userUpdationSuccess: ''
      }
    case USER_UPDATE_SUCCESS:
      return {
        ...state,
        childUserList: null,
        userUpdationSuccess: 'success',
        snackbar: {
          open: true,
          type: 'success',
          duration: null,
          message: action.msg || 'User updated successfully'
        }
      }
    case USER_UPDATE_FAIL:
      return {
        ...state,
        userUpdationSuccess: 'failure',
        snackbar: {
          open: true,
          type: 'error',
          duration: null,
          message:
            action.errMsg || 'Some error occurred, please try after some time'
        }
      }
    case SHOW_LOADER:
      return {
        ...state,
        showLoader: true
      }
    case HIDE_LOADER:
      return {
        ...state,
        showLoader: false
      }
    case ACCOUNT_PAYMENT_BUCKET_DETAILS_IN_PROGRESS:
      return {
        ...state,
        isFetching: true
      }
    case ACCOUNT_PAYMENT_BUCKET_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false
      }
    case ACCOUNT_PAYMENT_BUCKET_DETAILS_ERROR:
      return {
        ...state,
        isFetching: false,
        snackbar: {
          open: true,
          message: action.msg
        }
      }
    case YES_BANK_AMOUNT_TRANSFER_SUCCESS:
      return {
        ...state,
        snackbar: {
          open: true,
          message: action.msg
        }
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/